var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    role: "img",
    "aria-label": "USB-C hub",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    rx: 10,
    fill: "#F3EEFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 44,
    width: 88,
    height: 32,
    rx: 8,
    fill: "#002454"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 52,
    width: 10,
    height: 16,
    rx: 2,
    fill: "#9e00ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 52,
    width: 10,
    height: 16,
    rx: 2,
    fill: "#9e00ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 52,
    width: 10,
    height: 16,
    rx: 2,
    fill: "#9e00ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 52,
    width: 10,
    height: 16,
    rx: 2,
    fill: "#9e00ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 52,
    width: 8,
    height: 16,
    rx: 2,
    fill: "#fff",
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 44 V32",
    stroke: "#002454",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 28,
    r: 5,
    fill: "#9e00ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductHub);
export default __webpack_public_path__ + "static/media/product-hub.97c0fb798d35a53a4608c74ceebf1953.svg";
export { ForwardRef as ReactComponent };